// edit-input.hooks.ts
import * as React from 'react';

type UseEditInputArgs = {
  placeholder?: string;
  value?: React.InputHTMLAttributes<HTMLInputElement>['value'];
};

export const useEditInput = ({ placeholder, value }: UseEditInputArgs) => {
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  const handleIconClick = React.useCallback(() => {
    const input = inputRef.current;
    if (!input) return;

    const isControlled = value !== undefined;

    // If uncontrolled and empty, populate with placeholder as value
    if (!isControlled && !input.value && placeholder) {
      input.value = placeholder;
    }

    input.focus();

    // Move cursor to the end of the text
    const length = input.value.length;
    // setSelectionRange can throw for certain input types, but this component uses type="text"
    input.setSelectionRange(length, length);
  }, [placeholder, value]);

  return { inputRef, handleIconClick };
};
